import DragDistanceHelper from '../../../tools/drag-distance-helper';
import MoveTool from './move-tool';
import OrbitTool from './orbit-tool';
import PanZoomTool from './pan-zoom-tool';
import SelectTool from './select-tool';
import Signal from '../../../control-flow/signal';
import Tool from '../../../tools/tool';
import UnitEditorApp from '../unit-editor-app';
import logging from '../../../logging';

const log = logging('tools');

enum MultiToolMode {
    FRONT,
    PERSPECTIVE,
}

export default class MultiTool extends Tool {

    app: UnitEditorApp;
    orbit: OrbitTool;
    panzoom: PanZoomTool;
    move: MoveTool;
    select: SelectTool;
    helper: DragDistanceHelper;

    static FRONT = MultiToolMode.FRONT;
    static PERSPECTIVE = MultiToolMode.PERSPECTIVE;

    onModeChange = new Signal<[MultiToolMode]>('onModeChange', 'tools');

    private enabled: boolean = false;
    private _mode: MultiToolMode = MultiTool.FRONT;

    constructor(app: UnitEditorApp) {
        super();
        this.app = app;
        this.helper = new DragDistanceHelper(app);
        this.orbit = new OrbitTool(app);
        this.panzoom = new PanZoomTool(app);
        this.move = new MoveTool(app, this.helper);
        this.select = new SelectTool(app, this.helper);
    }

    set mode(mode: MultiToolMode) {
        if(this._mode != mode) {
            this._mode = mode;
            this.updateChildToolState();
            this.onModeChange.trigger(mode);
        }
    }

    get mode(): MultiToolMode {
        return this._mode;
    }

    private updateChildToolState() {
        if(this.enabled) {
            switch(this.mode) {
                case MultiToolMode.FRONT:
                    this.select.enable();
                    this.move.enable();
                    this.orbit.disable();
                    this.panzoom.enable();
                    break;
                case MultiToolMode.PERSPECTIVE:
                    this.orbit.enable();
                    this.select.disable();
                    this.move.disable();
                    this.panzoom.disable();
                    break;
            }
        }
    }

    enable(): void {
        log.debug('MultiTool.enable');
        this.enabled = true;
        this.helper.enable();
        this.updateChildToolState();
    }

    disable(): void {
        log.debug('MultiTool.disable');
        this.enabled = false;
        this.orbit.disable();
        this.move.disable();
        this.select.disable();

        this.helper.disable();
    }

    begin(): void {
        log.debug('MultiTool.begin');
    }

    cancel(): void {
        log.debug('MultiTool.cancel');
    }

    end(): void {
        log.debug('MultiTool.end');
    }

}
